// App.js

import React from 'react';
import AgevolazioniList from './AgevolazioniList';

const App = () => (
  <div className="app">
    {/* Altri componenti della tua applicazione */}
    <AgevolazioniList />
  </div>
);

export default App;

